/**
 * Citibox brand palette tokens (design-language: Electric Purple), mirrored as
 * named tokens for direct reference (e.g. the /ui-kit showcase). The theme in
 * ./index.ts consumes these so the named tokens and the live theme never drift.
 * See docs/DESIGN.md §2.
 */
export const citiboxColors = {
  primary: '#7942ED', // Electric Purple — primary actions
  primaryDark: '#552EA6', // Deep Purple — pressed states
  primaryLight: '#B294F3', // Soft Lavender — highlights
  // Pale brand fill for the container of a value that must be found first (the lock-code
  // «siguiente» slot). A surface, not an action: never used for a control's background, and
  // light enough that `primary` and `textPrimary` both clear contrast on it.
  primarySurface: '#F1EAFE',
  secondary: '#0ECECF', // Vibrant Teal — decorative accents
  secondaryDark: '#0BAFAF',
  success: '#2ED25C',
  warning: '#F0AA22',
  error: '#F26279',
  info: '#2775FF',
  textPrimary: '#50495E', // Dark Purple-Gray — headings/body (never pure black)
  textSecondary: '#ACA5BB', // Soft Lavender-Gray — secondary/placeholder
  surface: '#EEEEEF', // Light Gray-Lavender — input/section fills
  background: '#FFFFFF',
  divider: 'rgba(69, 64, 79, 0.12)', // tonal hairline (Figma 67:953)
  grey: {
    '50': '#fafafa',
    '100': '#f5f5f5',
    '200': '#eeeeee',
    '300': '#e0e0e0',
    '400': '#bdbdbd',
    '500': '#9e9e9e',
    '600': '#757575',
    '700': '#616161',
    '800': '#424242',
    '900': '#212121',
  },
} as const;

export type CitiboxColors = typeof citiboxColors;
